<div class="container-fluid pt-3 pb-3 channel-theme-a2 history-analytics-viewport d-flex flex-column">
  <div class="row g-3 mb-3 align-items-stretch flex-shrink-0">
    <div [ngClass]="outputCount > 1 ? 'col-lg-4' : 'col-lg-6'">
      <div class="card h-100 position-relative">
        <button type="button" class="btn btn-outline-primary btn-sm position-absolute top-0 end-0 m-2"
          (click)="refreshChannelHistory()" [disabled]="loadingHistory"
          title="{{ 'do_update' | translate }}">
          <i class="fas fa-sync-alt" [class.fa-spin]="loadingHistory"></i>
        </button>
        <div class="card-body d-flex align-items-center gap-3 py-2 px-3 h-100 pe-5">
          <img [src]="deviceImage" [attr.alt]="'info' | translate" height="56" class="flex-shrink-0">
          <div class="min-w-0">
            <h6 class="fw-bold text-primary mb-0 text-truncate">{{ deviceDisplayName }}</h6>
            <small class="text-muted d-block">ID: {{ deviceDisplayId }}</small>
            <small class="text-muted d-block mt-1" *ngIf="lastUpdated">
              {{ 'updated' | translate }}: {{ formatDateTime(lastUpdated) }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="outputCount > 1 ? 'col-lg-4' : 'col-lg-6'">
      <div class="card h-100 border-start border-4 d-flex align-items-center justify-content-center py-2"
        *ngIf="loadingHistory">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">{{ 'loading' | translate }}</span>
        </div>
      </div>
      <div class="card h-100 border-start border-4"
        *ngIf="!loadingHistory && latestChannelRecord as latest"
        [ngClass]="getStatusCardClass(latest.c1stat)"
        [ngStyle]="getStatusCardStyle(latest.c1stat)">
        <div class="card-body d-flex align-items-center gap-3 py-2 px-3 h-100">
          <div class="channel-bulb-icon channel-bulb-icon--lg position-relative flex-shrink-0">
            <i class="fas fa-lightbulb fa-2x" [ngClass]="getChannelBulbClass(latest.c1stat)"></i>
            <i class="fas fa-hand-pointer channel-bulb-overlay channel-bulb-overlay--lg"
              *ngIf="isChannelManual(latest.c1stat)"></i>
            <i class="fas fa-clock channel-bulb-overlay channel-bulb-overlay--lg"
              *ngIf="!isChannelManual(latest.c1stat)"></i>
          </div>
          <div class="min-w-0">
            <small class="text-muted d-inline-flex align-items-center gap-1 mb-0">
              {{ 'out' | translate }}: 1
              <i class="fa-solid fa-lock text-warning" *ngIf="isOutputPermanent(1)"></i>
              <i class="fa-solid fa-unlock text-muted" *ngIf="!isOutputPermanent(1)"></i>
            </small>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <span [ngClass]="getChannelPowerClass(latest.c1stat)">
                {{ getChannelPowerLabelKey(latest.c1stat) | translate }}
              </span>
              <span [ngClass]="getChannelModeBadgeClass(latest.c1stat)">
                {{ getChannelModeLabelKey(latest.c1stat) | translate }}
              </span>
            </div>
            <small class="text-muted">{{ 'contador' | translate }}: {{ latest.c1counter }} h </small>
          </div>
        </div>
      </div>
      <div class="card h-100 border-start border-4 border-secondary"
        *ngIf="!loadingHistory && !latestChannelRecord">
        <div class="card-body d-flex align-items-center py-2 px-3 h-100">
          <span class="text-muted small"> {{'ancHistoricsPlaceholder' | translate}} — {{'out' | translate}}: 1</span>
        </div>
      </div>
    </div>

    <div class="col-lg-4" *ngIf="outputCount > 1">
      <div class="card h-100 border-start border-4 d-flex align-items-center justify-content-center py-2"
        *ngIf="loadingHistory">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">{{ 'loading' | translate }}</span>
        </div>
      </div>
      <div class="card h-100 border-start border-4"
        *ngIf="!loadingHistory && latestChannelRecord as latest"
        [ngClass]="getStatusCardClass(latest.c2stat)"
        [ngStyle]="getStatusCardStyle(latest.c2stat)">
        <div class="card-body d-flex align-items-center gap-3 py-2 px-3 h-100">
          <div class="channel-bulb-icon channel-bulb-icon--lg position-relative flex-shrink-0">
            <i class="fas fa-lightbulb fa-2x" [ngClass]="getChannelBulbClass(latest.c2stat)"></i>
            <i class="fas fa-hand-pointer channel-bulb-overlay channel-bulb-overlay--lg"
              *ngIf="isChannelManual(latest.c2stat)"></i>
            <i class="fas fa-clock channel-bulb-overlay channel-bulb-overlay--lg"
              *ngIf="!isChannelManual(latest.c2stat)"></i>
          </div>
          <div class="min-w-0">
            <small class="text-muted d-inline-flex align-items-center gap-1 mb-0">
              {{'out' | translate}}: 2
              <i class="fa-solid fa-lock text-warning" *ngIf="isOutputPermanent(2)"></i>
              <i class="fa-solid fa-unlock text-muted" *ngIf="!isOutputPermanent(2)"></i>
            </small>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <span [ngClass]="getChannelPowerClass(latest.c2stat)">
                {{ getChannelPowerLabelKey(latest.c2stat) | translate }}
              </span>
              <span [ngClass]="getChannelModeBadgeClass(latest.c2stat)">
                {{ getChannelModeLabelKey(latest.c2stat) | translate }}
              </span>
            </div>
            <small class="text-muted">{{ 'contador' | translate }}: {{ latest.c2counter }} h</small>
          </div>
        </div>
      </div>
      <div class="card h-100 border-start border-4 border-secondary"
        *ngIf="!loadingHistory && !latestChannelRecord">
        <div class="card-body d-flex align-items-center py-2 px-3 h-100">
          <span class="text-muted small"> {{'ancHistoricsPlaceholder' | translate}} — {{'out' | translate}}: 2</span>
        </div>
      </div>
    </div>
  </div>

  <h6 class="fw-bold text-primary mb-3 flex-shrink-0">{{ 'ActivityClock' | translate }}</h6>

  <div class="card history-analytics-table-card flex-grow-1 d-flex flex-column min-h-0 mb-0 overflow-hidden">
    <div class="card-body p-0 d-flex flex-column flex-grow-1 min-h-0">
      <div *ngIf="loadingHistory" class="flex-grow-1 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'loading' | translate }}</span>
        </div>
      </div>
      <div class="table-responsive flex-grow-1 overflow-auto min-h-0" *ngIf="!loadingHistory">
        <table class="table table-hover mb-0 align-middle">
          <thead class="table-light sticky-top">
            <tr>
              <th class="small">{{ 'datetime' | translate }}</th>
              <th class="small">{{ 'output1Hours' | translate }}</th>
              <th class="small text-end">{{ 'contador' | translate }} 1</th>
              <th class="small" *ngIf="outputCount > 1">{{ 'output2Hours' | translate }}</th>
              <th class="small text-end" *ngIf="outputCount > 1">{{ 'contador' | translate }} 2</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="dataHistory.length === 0">
              <td [attr.colspan]="outputCount > 1 ? 5 : 3" class="text-center text-muted py-4">
                {{'ancHistoricsPlaceholder' | translate}}
              </td>
            </tr>
            <tr *ngFor="let record of paginatedHistory">
              <td class="small">{{ formatDateTime(record.timestamp) }}</td>
              <td class="small">
                <span [ngClass]="getStatusPillClass(record.c1stat)">
                  <span class="channel-bulb-icon channel-bulb-icon--sm position-relative d-inline-block">
                    <i class="fas fa-lightbulb" [ngClass]="getChannelBulbClass(record.c1stat)"></i>
                    <i class="fas fa-hand-pointer channel-bulb-overlay"
                      *ngIf="isChannelManual(record.c1stat)"></i>
                    <i class="fas fa-clock channel-bulb-overlay"
                      *ngIf="!isChannelManual(record.c1stat)"></i>
                  </span>
                  {{ getChannelPowerLabelKey(record.c1stat) | translate }}
                  ({{ getChannelModeLabelKey(record.c1stat) | translate }})
                </span>
              </td>
              <td class="small text-end">{{ record.c1counter }}</td>
              <td class="small" *ngIf="outputCount > 1">
                <span [ngClass]="getStatusPillClass(record.c2stat)">
                  <span class="channel-bulb-icon channel-bulb-icon--sm position-relative d-inline-block">
                    <i class="fas fa-lightbulb" [ngClass]="getChannelBulbClass(record.c2stat)"></i>
                    <i class="fas fa-hand-pointer channel-bulb-overlay"
                      *ngIf="isChannelManual(record.c2stat)"></i>
                    <i class="fas fa-clock channel-bulb-overlay"
                      *ngIf="!isChannelManual(record.c2stat)"></i>
                  </span>
                  {{ getChannelPowerLabelKey(record.c2stat) | translate }}
                  ({{ getChannelModeLabelKey(record.c2stat) | translate }})
                </span>
              </td>
              <td class="small text-end" *ngIf="outputCount > 1">{{ record.c2counter }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="history-analytics-footer flex-shrink-0 d-flex justify-content-between align-items-center px-3 py-2 border-top small text-muted"
        *ngIf="!loadingHistory && dataHistory.length > 0">
        <span>{{ 'showingRecordsOf' | translate:{ from: paginationFrom, to: paginationTo, total: dataHistory.length } }}</span>
        <nav [attr.aria-label]="'astronomicalClockHistorics' | translate" *ngIf="totalPages > 1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button type="button" class="page-link" (click)="goToPreviousPage()" [disabled]="currentPage === 1">
                {{'previous' | translate}}
              </button>
            </li>
            <li class="page-item"
              *ngFor="let page of paginationPages"
              [class.active]="currentPage === page">
              <button type="button" class="page-link" (click)="goToPage(page)">{{ page }}</button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button type="button" class="page-link" (click)="goToNextPage()" [disabled]="currentPage === totalPages">
                {{'following' | translate}}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
